import { render, staticRenderFns } from "./indexorder.vue?vue&type=template&id=fd8f5e08&scoped=true"
import script from "./indexorder.vue?vue&type=script&lang=js"
export * from "./indexorder.vue?vue&type=script&lang=js"
import style0 from "./indexorder.vue?vue&type=style&index=0&id=fd8f5e08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd8f5e08",
  null
  
)

export default component.exports